<article [class.position-top-left]="iconPosition === 'top-left'" [class.action-type]="type === 'action'" [class.note]="type === 'note'" [class.success]="state === 'success'" [class.warning]="state === 'warning'" [class.error]="state === 'error'">
  <div>
    @if (_icon()) {
      <span class="icon {{ _iconName }}" title="{{ iconTooltip }}"><i class="mdi {{ _icon() }} {{ iconColour }}"></i> </span>
    }
    <ng-content></ng-content>
  </div>
</article>
